var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-switch",class:{ 'is-checked': _vm.value },attrs:{"role":"switch","aria-checked":"true"},on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span',{staticClass:"my-switch__core"})])}
var staticRenderFns = []

export { render, staticRenderFns }